import { takeEvery } from 'redux-saga'
import { call, put } from 'redux-saga/effects'
import fetcher from 'modules/fetcher'
import { t } from 'i18n/utils'

import {
  quickFillApplySuccess,
  quickFillApplyFailure,
  quickFillUndoSuccess,
  quickFillUndoFailure
} from './actions'

import {
  QUICK_FILL_APPLY_SUBMIT,
  QUICK_FILL_UNDO_SUBMIT
} from './constants'

import { dealProfileFetch } from 'Deals/actions'
import { companyProfileFetch } from 'Companies/actions'
import { personProfileFetch } from 'People/actions'
import { customerProfileFetch } from 'Customers/actions'

function * refreshProfile (recordType, recordId) {
  const id = parseInt(recordId, 10)
  const path = window.location.pathname
  if (recordType === 'deal') {
    yield put(dealProfileFetch({ dealId: id }))
  } else if (recordType === 'company' && path.includes('/customers/')) {
    const match = path.match(/\/customers\/(\d+)/)
    if (match) yield put(customerProfileFetch({ customerId: parseInt(match[1], 10) }))
  } else if (recordType === 'company') {
    yield put(companyProfileFetch({ companyId: id }))
  } else if (recordType === 'person') {
    yield put(personProfileFetch({ personId: id }))
  }
}

function * applySaga ({ payload }) {
  const { templateId, recordId, recordType } = payload
  try {
    const response = yield call(
      fetcher,
      'api/v3/quick_fill_applications',
      {
        method: 'POST',
        body: JSON.stringify({ quick_fill_template_id: templateId, record_id: recordId })
      }
    )

    yield put(quickFillApplySuccess(response))

    const applicationId = response.quick_fill_application_id
    if (applicationId) {
      window.Helpers.notify(t('quickFills.templateApplied'), {
        type: 'success',
        message: `<a href="#" class="js-quick-fill-undo" data-quick-fill-application-id="${applicationId}" data-record-type="${recordType}" data-record-id="${recordId}">${t('quickFills.templateAppliedUndo')}</a> ${t('quickFills.templateAppliedUndoMessage')}`
      })
    } else {
      window.Helpers.notify(t('quickFills.templateApplied'), { type: 'success', message: t('quickFills.templateAppliedNoChanges') })
    }

    yield * refreshProfile(recordType, recordId)
  } catch (e) {
    yield put(quickFillApplyFailure(e.message))
    window.Helpers.notify(t('quickFills.templateApplyError'), { type: 'error', message: t('quickFills.templateApplyErrorRetry') })
  }
}

function * watchApplySaga () {
  yield call(takeEvery, QUICK_FILL_APPLY_SUBMIT, applySaga)
}

function * undoSaga ({ payload }) {
  const { quickFillApplicationId, recordType, recordId } = payload
  try {
    yield call(
      fetcher,
      `api/v3/quick_fill_applications/${quickFillApplicationId}`,
      {
        method: 'DELETE'
      }
    )

    yield put(quickFillUndoSuccess())
    window.Helpers.notify(t('quickFills.changesRemoved'), { message: t('quickFills.noTemplateApplied') })

    yield * refreshProfile(recordType, recordId)
  } catch (e) {
    yield put(quickFillUndoFailure(e.message))
  }
}

function * watchUndoSaga () {
  yield call(takeEvery, QUICK_FILL_UNDO_SUBMIT, undoSaga)
}

export const quickFillSagas = [
  watchApplySaga(),
  watchUndoSaga()
]
